import React from 'react'
import { SHIPPING, SHIPPING_LINK } from '../../helpers/constants'
import type { SectionProps } from './Section'
import Section from './Section'

const Component = (props: SectionProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const { currentSection, onToggle, section } = props
  return (
    <Section
      name={SHIPPING}
      title='How does shipping work?'
      {...{
        currentSection,
        onToggle,
        section,
      }}
    >
      <p>
        Once you sell an artwork, you will receive an email informing you of the sale. You will need
        to schedule a date and time for our courier to pick up your sold artwork. We’ll also supply
        you with any shipping documents and labels you may need. Don’t worry about covering the
        shipping costs, as the collector is responsible for the cost of shipping. You are only
        responsible for the cost of packaging your artwork.{' '}
        <a data-type='link' target='_blank' rel='noopener noreferrer' href={SHIPPING_LINK}>
          Learn More
        </a>
      </p>
    </Section>
  )
}

export default Component